import React, { useRef } from 'react';
import { MenuItem } from '../../../components/Menu';
import addIcon from '../../../icons/add.svg';
import styles from './AddAttachmentMenuItem.module.scss';

interface AddAttachmentMenuItemProps {
  onUpload: React.ChangeEventHandler<HTMLInputElement>;
}

const AddAttachmentMenuItem = ({ onUpload }: AddAttachmentMenuItemProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        onChange={onUpload}
        className={styles.input}
        multiple
        aria-labelledby="aria-add-attachment-menu-item"
      />
      <MenuItem
        icon={addIcon}
        onClick={() => inputRef.current?.click()}
        id="aria-add-attachment-menu-item"
      >
        Add more files
      </MenuItem>
    </>
  );
};

export default AddAttachmentMenuItem;
